import React, { useEffect, useMemo, useState } from "react";
import { Modal, Button, Input, Row, Col, Select, Divider } from "antd";
import axios from "axios";

const POS = ["FL", "FR", "RL", "RR"];
const LABEL = {
  FL: "Delantera Izquierda",
  FR: "Delantera Derecha",
  RL: "Trasera Izquierda",
  RR: "Trasera Derecha",
};
const MANUAL = "__manual__";

export default function ModalCubiertas({
  open,
  onClose,
  contexto, // {id_piloto,id_categoria,id_carrera,pilotoNombre}
  onGuardado, // refrescar tabla si querés
	MySwal
}) {
  const [loading, setLoading] = useState(false);
  const [series, setSeries] = useState({ FL: "", FR: "", RL: "", RR: "" });
  const [historial, setHistorial] = useState({ FL: [], FR: [], RL: [], RR: [] });
  const [mostrarCopiar, setMostrarCopiar] = useState(false);
	const [cantidad, setCantidad] = useState(0);
  const [max, setMax] = useState(20);

  // para select por rueda
  const [histSelect, setHistSelect] = useState({
    FL: MANUAL, FR: MANUAL, RL: MANUAL, RR: MANUAL,
  });

  const headers = useMemo(() => ({
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }), []);

  useEffect(() => {
    if (!open || !contexto) return;
    cargar();
    // eslint-disable-next-line
		obtenerCubiertas();
  }, [open, contexto?.id_piloto, contexto?.id_categoria, contexto?.id_carrera]);

  const cargar = async () => {
    try {
      setLoading(true);

      // 1) obtener cubiertas actuales
      const resp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/obtener`,
        { ...headers, params: contexto }
      );
      setSeries(resp.data?.series || { FL: "", FR: "", RL: "", RR: "" });

      // 2) historial
      const hist = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/historial`,
        { ...headers, params: contexto }
      );
      setHistorial(hist.data || { FL: [], FR: [], RL: [], RR: [] });

      // 3) disponible copiar
      const disp = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/disponible-carrera-pasada`,
        { ...headers, params: contexto }
      );
      setMostrarCopiar(!!disp.data?.disponible);

      // reset selects
      setHistSelect({ FL: MANUAL, FR: MANUAL, RL: MANUAL, RR: MANUAL });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

	const obtenerCubiertas = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/numero-cubierta/obtener`, {
        params: {
          id_piloto: Number(contexto.id_piloto),
          id_categoria: Number(contexto.id_categoria),
          id_carrera: Number(contexto.id_carrera),
        },
      });
      // console.log("reponse", response.data)
      if (response.status === 200) {
        setCantidad(response.data.cantidadUnicas ?? 0);
        setMax(response.data?.maximo || 20);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const setSerie = (pos, value) => {
    setSeries((prev) => ({ ...prev, [pos]: value }));
  };

  const guardar = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/guardar`,
        {
          ...contexto,
          series,
          tipoMod: "ADMIN",
        },
        headers
      );

      if (response.status == 200) {
        MySwal.fire({
          title: "Número de cubiertas asignadas con éxito",
          text: "El número de cubiertas ha sido asignado correctamente.",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });

        onGuardado?.();
        onClose();
      }
    } catch (e) {
      const msg = e?.response?.data?.message || "Error al guardar cubiertas";
      alert(msg);
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const copiarCarreraPasada = async () => {
    try {
      setLoading(true);
      const resp = await axios.post(
        `${process.env.REACT_APP_DOMINIO}/numero-cubierta/copiar-carrera-pasada`,
        contexto,
        headers
      );
      setSeries(resp.data?.series || series);
    } catch (e) {
      alert(e?.response?.data?.message || "No se pudo copiar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={`Cubiertas - ${contexto?.pilotoNombre || ""} (${cantidad}/${max})`}
      footer={null}
      destroyOnClose
    >
      <Divider style={{ margin: "10px 0" }} />

      {POS.map((pos) => {
        const opciones = historial?.[pos] || [];
        const mostrarSelect = opciones.length > 0;

        return (
          <div key={pos} style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{LABEL[pos]}</div>

            <Row gutter={8}>
              <Col span={10}>
                {mostrarSelect ? (
                  <Select
                    style={{ width: "100%" }}
                    value={histSelect[pos]}
                    onChange={(val) => {
                      setHistSelect((prev) => ({ ...prev, [pos]: val }));
                      if (val !== MANUAL) setSerie(pos, val);
                    }}
                    options={[
                      { label: "Escribir manualmente...", value: MANUAL },
                      ...opciones.map((x) => ({ label: x, value: x })),
                    ]}
                  />
                ) : (
                  <Select
                    style={{ width: "100%" }}
                    value={MANUAL}
                    disabled
                    options={[{ label: "Sin historial", value: MANUAL }]}
                  />
                )}
              </Col>

              <Col span={14}>
                <Input
                  value={series?.[pos] || ""}
                  placeholder="Ej: AB 1234"
                  onChange={(e) => {
                    setHistSelect((prev) => ({ ...prev, [pos]: MANUAL }));
                    setSerie(pos, e.target.value);
                  }}
									style={{
										height: 32
									}}
                />
              </Col>
            </Row>
          </div>
        );
      })}

      <Divider style={{ margin: "10px 0" }} />

			<Row gutter={8} justify="end">
        {mostrarCopiar && (
          <Col xs={24} sm={24}>
            <Button 
							style={{
								width: "100%",
								backgroundColor: "#233463",
								color: "#FFF",
								fontSize: 18,
								cursor: "pointer"
							}}
							onClick={copiarCarreraPasada} 
							loading={loading}>
              Mismas cubiertas que la carrera pasada
            </Button>
          </Col>
        )}
			</Row>

      <Row gutter={16} justify="end" style={{ marginTop: 10 }}>
				<Col xs={24} sm={12}>
					<Button 
						style={{
							width: "100%",
							backgroundColor: "#233463",
							color: "#FFF",
							fontSize: 18,
							cursor: "pointer"
						}}
						onClick={onClose} 
						loading={loading}>
						Cancelar
					</Button>
				</Col>
        <Col xs={24} sm={12}>
          <Button 
						type="primary" 
						onClick={guardar} 
						loading={loading} 
						style={{
							width: "100%",
							backgroundColor: "#BA1721",
							color: "#FFF",
							fontSize: 18,
							cursor: "pointer"
						}}>
            Guardar
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}